
<template>
  <div class="listItem" :class="expanded ? 'coloredBorder' : ''">

    <div class="listItemHeader">
        <toggle-button @change="changeAllConsent($event)" :sync=true :value="allConsent" :width="64" :height="30" :speed="200" :color="{checked: '#34b76f', unchecked: '#94a7d1'}" /> 
        <div class="listLabel">Consent to Processing of Sensitive Data</div>
          <div class="toggleContainer">
            <div class="spacer"></div>
            <div style="flex-grow:1;"></div>
            <ChevronIcon @click="expandCollapseClick" :class="collapseClass"/>
          </div>
    </div>

    <Vue3SlideUpDown v-model="expanded" :duration="200" class="listItemDetail">

      <p style="margin-left:8px;">{{ leadText }}</p>
      <div class="sensitiveItemList">
        <SensitiveDataItem v-for="(feature, i) in sensitiveFeatures" :ref="setItemRef" :key="i" :sync=true :value="consentValues[i]" @modelChangeEvent="changeFeatureConsent(i)" :label="feature.description" />    
      </div>

    </Vue3SlideUpDown>

  </div>
</template>

<script>

import ChevronIcon from '../icons/ChevronIcon.vue'
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ToggleButton from './ToggleButton.vue';
import SensitiveDataItem from './SensitiveDataItem.vue';
import { reactive } from 'vue';

export default {

  components: {
    ToggleButton,
    SensitiveDataItem,
    ChevronIcon,
    Vue3SlideUpDown
  },
  
  props: {
    cmpApi: {},
    sectionName: "",
    fieldName: "",
    
    leadText: { default:"Consent to Processing of Sensitive Data Consisting of:" },
    sensitiveFeatures: {
      default:[
        { position: 1, description: "Personal Data Revealing Racial or Ethnic Origin." },
        { position: 2, description: "Personal Data Revealing Religious Beliefs." },
        { position: 3, description: "Personal Data Revealing a Mental or Physical Health Condition or Diagnosis." },
        { position: 4, description: "Personal Data Revealing Sex Life or Sexual Orientation." },
        { position: 5, description: "Personal Data Revealing Citizenship or Immigration Status." },
        { position: 6, description: "Genetic Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
        { position: 7, description: "Biometric Data that May Be Processed for the Purpose of Uniquely Identifying an Individual." },
        { position: 8, description: "Precise Geolocation Data." }
        ]    }
    },
      
    data() {
      return {
        allConsent: true,
        expanded: true,
        allConsent: false,
        collapseClass: "collapseButton collapseButtonRotatedDown",
        itemRefs: [],
        consentValues: [],
        sensitiveDataConsents: []

      }
    },

    mounted() {

      if ( this.cmpApi.hasSection( this.sectionName ) ) {
        this.sensitiveDataConsents = this.cmpApi.getFieldValue(this.sectionName, this.fieldName);
      } else {
        this.sensitiveDataConsents.length = this.sensitiveFeatures.length;
        this.sensitiveDataConsents.fill( 2 );
      }

      console.log("SensitiveDataList mounted() sensitiveDataConsents = " + this.sensitiveDataConsents);

      this.sensitiveDataConsents.forEach( (v, i) => { this.consentValues[i] = v == 2 ? true : false } );
      console.log("SensitiveDataList mounted() consentValues = " + this.consentValues);

      this.itemRefs.forEach( (r,i) => r.value = this.consentValues[i] );

      this.allConsent = this.consentValues.every( (v) => v ) ? true : false;

      setTimeout( () => {  if ( this.allConsent ) this.expandCollapseClick(); }, 350 );
    },
	
	methods: {
		setItemRef(el) {
		  if (el) {
			this.itemRefs.push(el)
		  }
		},

		expandCollapseClick() {
		  if ( ! this.expanded )
			this.collapseClass = 'collapseButton collapseButtonRotatedDown';
		  else
			this.collapseClass = 'collapseButton collapseButtonRotatedUp';
		  this.expanded = ! this.expanded;

      this.itemRefs.forEach( (r,i) => r.value = this.consentValues[i] );
		},
	
		changeFeatureConsent( i ) {
		  this.consentValues[i] = ! this.consentValues[i];
      this.sensitiveDataConsents = this.consentValues.map( v =>  v ? 2 : 1);  // 2 = did not opt out, 1 = opted out
		  this.allConsent = this.consentValues.every( (v) => v ) ? true : false;

      this.cmpApi.setFieldValue(this.sectionName, this.fieldName, this.sensitiveDataConsents);

      this.$emit('modelChangeEvent',this.consentValues);

		},

		changeAllConsent( event ) {
		  this.allConsent = !this.allConsent;
		  this.itemRefs.forEach( v => v.value = this.allConsent );

      this.consentValues.fill(this.allConsent);	  
      this.sensitiveDataConsents = this.consentValues.map( v =>  v ? 2 : 1);  // 2 = did not opt out, 1 = opted out

      this.cmpApi.setFieldValue(this.sectionName, this.fieldName, this.sensitiveDataConsents);

      this.$emit('modelChangeEvent',this.consentValues);
		}
	}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

 p {
    font-size: 15.5px;
    text-align: left;
    padding: 0 24px;
    font-weight: 500;
    margin: 12px 0 8px 0;
}

.spacer {
   flex-grow:1;
}

.toggleContainer {
  display:flex;
  flex-direction:row;
  flex-grow:1;
}

.listItem {
    display:flex;
    flex-direction:column;
    border: 1px solid;
    border-color: #f9f9ff;
    border-radius:12px;
    transition: border-color 0.8s linear;
    padding:2px 0;
    margin-bottom:4px;
}

.listItemHeader {
    display:flex;
    flex-direction:row;
    margin: 4px 8px 4px 24px;
}

.listLabel {
  font-size:18px;
  font-weight:500;
  color:#666;
  margin-top:3px;
  margin-left:12px;
  text-align:left;
}

.listItemDetail {
  margin-bottom:12px;
  max-width: 700px;     // prevent stupid long privacy policy URLs from exceeding layout width (Ströer SSP GmbH)
  overflow:hidden;
}

.sensitiveItemList {
  text-align:left;
  font-weight:300;
  margin:0 8px 8px 24px;
  font: size 16px;
  display:flex;
  flex-direction:column;
}
.collapseButton {
    transition: 0.2s ease-in-out;
  cursor:pointer !important;
}
.collapseButtonRotatedUp {
  transform: rotate(0);
}
.collapseButtonRotatedDown {
  transform: rotate(-90deg);
}


//////////////////////////////////
//////////////////////////////////
//  mobile
//////////////////////////////////
//////////////////////////////////

@media (max-width: 900px) {
  .listItemHeader {
    flex-direction:column;
    }
      
  .listLabel {
    font-size:13px !important;
    text-align:left;
    margin-bottom:5px;
  }

  .sensitiveItemList {
  font-size:12px;
}

}

//////////////////////////////////
//////////////////////////////////

</style>
